// extracted by mini-css-extract-plugin
module.exports = {"select":"UserAddContent_select__30yWS","tagify":"UserAddContent_tagify__2Lh6Y"};